const generateVariants = function () {
  let base = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 6;
  let suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'px';
  return {
    default: "".concat(base).concat(suffix),
    double: "".concat(base * 2).concat(suffix),
    half: "".concat(base / 2).concat(suffix),
    quarter: "".concat(base / 4).concat(suffix)
  };
};

export { generateVariants };
